import { useAuth } from "@/contexts/AuthContext";
import { fetchSessions } from "@/services/sessions.queries";
import { useToastNotify } from "@/stores/toastStore";
import { useQuery } from "@tanstack/react-query";
import { useT } from "@transifex/react";
import { useState } from "react";

export const useSessionsData = () => {
  const { notify } = useToastNotify();
  const { user } = useAuth();
  const [errorNotified, setErrorNotified] = useState(false);
  const t = useT();

  const enableQuery = !!(user?.idToken && user?.idToken.length > 0);

  const { data, isFetching, isError, error, refetch } = useQuery({
    queryKey: ["sessions", user?.idToken],
    queryFn: () => fetchSessions({ cognitoIDToken: user?.idToken || "" }),
    enabled: enableQuery,
  });

  if (isError && !errorNotified) {
    notify({
      severity: "error",
      message: t("An error occurred when fetching sessions data"),
    });
    console.error("Error fetching sessions data:", error);
    setErrorNotified(true);
  }
  if (!isError && errorNotified) {
    setErrorNotified(false);
  }

  // This was causing the request to be called twice
  // useRefreshOnFocus(refetch, enableQuery);

  return {
    data,
    isFetching,
    refetch,
    enableQuery,
  };
};
